<template>
  <div class="insuranceCompanyManagement-container">
    <el-row>
      <el-form
        inline
        size="medium"
        :model="queryForm"
        ref="queryForm"
        class="input-form-inline"
        @submit.native.prevent
      >
        <el-form-item class="r-20" prop="companyName">
          <el-input
            v-model.trim="queryForm.companyName"
            placeholder="保险公司名称"
            @keyup.enter.native="query"
          ></el-input>
          <!-- <el-select
            v-model="queryForm.companyId"
            placeholder="请选择保险公司"
            clearable
          >
            <el-option
              v-for="item in companyList"
              :label="item.label"
              :value="item.value"
              :key="item.id"
            ></el-option>
          </el-select> -->
        </el-form-item>
        <el-form-item class="r-20" prop="contactsName">
          <el-input
            v-model.trim="queryForm.contactsName"
            placeholder="联系人"
            @keyup.enter.native="query"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="query">查询</el-button>
          <el-button @click="reset">取消</el-button>
        </el-form-item>
        <div>
          <el-button type="primary" @click="addCompany">新增</el-button>
        </div>
      </el-form>
    </el-row>
    <div style="height: 20px"></div>
    <el-row>
      <el-table :data="tableData" size="mini" stripe height="560px">
        <el-table-column width="20"></el-table-column>
        <el-table-column type="index" width="80" label="序号"></el-table-column>
        <el-table-column
          label="绑定账号"
          prop="account"
          min-width="100"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="保险公司名称"
          prop="companyName"
          min-width="180"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="联系人"
          prop="contactsName"
          min-width="80"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="联系电话"
          prop="phone"
          min-width="100"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="所属省"
          prop="provinceName"
          min-width="100"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="所属市"
          prop="cityName"
          min-width="100"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="所属区县"
          prop="areaName"
          min-width="100"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="详细地址"
          prop="address"
          min-width="160"
          show-overflow-tooltip
        ></el-table-column>
        <!-- <el-table-column label="状态" min-width="80" prop="state">
          <template slot-scope="{ row }">
            <span v-if="row.state == 1">开启</span>
            <span v-else-if="row.state == 2">关闭</span>
            <span v-else>-</span>
          </template>
        </el-table-column> -->
        <el-table-column label="操作" fixed="right" min-width="180">
          <template slot-scope="{ row }">
            <!-- <el-button
              type="text"
              @click="closeStatus(row, 2)"
              v-if="row.storeState == 1"
              >关闭</el-button
            >
            <el-button
              type="text"
              @click="closeStatus(row, 1)"
              v-else-if="row.storeState == 2"
              >开启</el-button
            > -->
            <el-button type="text" @click.stop="editor(row)">编辑</el-button>
            <el-button type="text" @click.stop="delData(row)">删除</el-button>
            <el-button type="text" @click.stop="checkDetails(row)"
              >详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-row>

    <!-- 新增/编辑弹框 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="insuranceCompanyDialog"
      @close="closeDialog"
    >
      <el-form
        size="mini"
        inline
        :model="insuranceCompanyForm"
        ref="editorForm"
        :rules="insuranceCompanyRules"
        label-position="left"
        label-width="auto"
        @submit.native.prevent
      >
        <el-row>
          <el-col :span="10">
            <el-form-item label="绑定账号：" prop="account">
              <el-select
                v-model="insuranceCompanyForm.account"
                placeholder="请选择绑定账号"
                clearable
              >
                <el-option
                  v-for="item in accountList"
                  :label="item.username"
                  :value="item.username"
                  :key="item.userId"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="2"></el-col>
          <el-col :span="12">
            <el-form-item label="保险公司名称：" prop="companyName">
              <el-input
                v-model.trim="insuranceCompanyForm.companyName"
                autocomplete="off"
                placeholder="请输入保险公司名称"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="联系人：" prop="contactsName">
              <el-input
                v-model.trim="insuranceCompanyForm.contactsName"
                autocomplete="off"
                placeholder="请输入联系人"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2"></el-col>
          <el-col :span="12">
            <el-form-item label="联系电话：" prop="phone">
              <el-input
                v-model.trim="insuranceCompanyForm.phone"
                autocomplete="off"
                placeholder="请输入联系电话"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="详细地址：" class="select-list" label-width="94px">
          <el-row>
            <el-col :span="6">
              <el-form-item prop="provinceId">
                <el-select
                  v-model="insuranceCompanyForm.provinceId"
                  placeholder="省"
                  class="select-item"
                  @visible-change="handleProvinceChange"
                >
                  <el-option
                    v-for="item in provinceList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="cityId">
                <el-select
                  v-model="insuranceCompanyForm.cityId"
                  placeholder="市"
                  class="select-item"
                  @visible-change="handleCityChange"
                >
                  <el-option
                    v-for="item in cityList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="areaId">
                <el-select
                  v-model="insuranceCompanyForm.areaId"
                  placeholder="区/县"
                  class="select-item"
                  @visible-change="handleAreaChange"
                >
                  <el-option
                    v-for="item in districtList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-form-item prop="address" style="margin-bottom: 0">
              <el-input
                type="textarea"
                :rows="2"
                placeholder="请输入详细地址"
                v-model.trim="insuranceCompanyForm.address"
              >
              </el-input>
            </el-form-item>
          </el-row>
        </el-form-item>

        <el-form-item
          label="上传资质证书：（请上传营业执照、授权证书，最大支持5张照片，单张照片最大不超过2M）"
          prop="certificateImg"
          style="display: flex; flex-direction: column; width: 100%"
        >
          <el-upload
            ref="failureImgUpload"
            :action="uploadUrl"
            accept=".jpg,.jpeg,.png"
            list-type="picture-card"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :auto-upload="true"
            :before-upload="uploadImage"
            :on-success="handleAvatarSuccess"
            :limit="5"
            class="normal-uploader"
            :class="{ hide: hideUploadEdit }"
            :file-list="uploadImageList"
          >
            <i class="el-icon-plus photos-uploader-icon"></i>
          </el-upload>
          <el-dialog
            :visible.sync="imageDialogVisible"
            append-to-body
            class="upload-dialog"
          >
            <img width="100%" :src="imgUrl" alt="" />
          </el-dialog>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveOrUpdate">保 存</el-button>
        <el-button @click="back">取 消</el-button>
      </div>
    </el-dialog>

    <!-- 详情弹框 -->
    <el-dialog
      class="details-dialog"
      title="详情"
      :visible.sync="dialogDetails"
    >
      <el-row class="row-line">
        <el-col :span="12">
          <el-col :span="5" class="label">绑定账号：</el-col>
          <el-col :span="10">{{ $judgeEmpty(detailsData.account) }}</el-col>
        </el-col>
        <el-col :span="12">
          <el-col :span="7" class="label">保险公司名称：</el-col>
          <el-col :span="10">{{ $judgeEmpty(detailsData.companyName) }}</el-col>
        </el-col>
      </el-row>
      <el-row class="row-line">
        <el-col :span="12">
          <el-col :span="4" class="label">联系人：</el-col>
          <el-col :span="10">{{
            $judgeEmpty(detailsData.contactsName)
          }}</el-col>
        </el-col>
        <el-col :span="12">
          <el-col :span="5" class="label">联系电话：</el-col>
          <el-col :span="10">{{ $judgeEmpty(detailsData.phone) }}</el-col>
        </el-col>
      </el-row>
      <el-row class="row-line">
        <el-col :span="3" class="label">详细地址：</el-col>
        <el-col :span="10">
          <el-row>{{ $judgeEmpty(detailsAddress) }}</el-row>
          <el-row>{{ $judgeEmpty(detailsData.address) }}</el-row>
        </el-col>
      </el-row>
      <el-row class="row-line">
        <el-row class="label">资质证书：</el-row>
        <el-row class="img-show-list">
          <el-image
            style="width: 200px; margin: 0 20px 20px 0"
            v-for="(item, index) in imgList"
            :key="index + item"
            :src="item"
            fit="contain"
            :preview-src-list="imgList"
          >
            <div slot="error" class="noData">未上传</div>
          </el-image>
        </el-row>
      </el-row>
    </el-dialog>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="currentPage"
      :page-size="limit"
      layout="total, prev, pager, next, jumper"
      :total="total"
    ></el-pagination>
  </div>
</template>

<script>
export default {
  name: "InsuranceCompanyManagement",
  data() {
    return {
      queryForm: {
        companyName: "",
        contactsName: "",
      },
      tableData: [],
      currentPage: 1,
      limit: 10,
      total: 0,
      dialogTitle: "",
      dialogVisible: false,
      dialogDetails: false,
      imageDialogVisible: false,
      provinceList: [],
      districtList: [],
      cityList: [],
      accountList: [],
      companyList: [],
      detailsData: {},
      insuranceCompanyForm: {
        account: "",
        companyName: "",
        contactsName: "",
        phone: "",
        provinceId: null,
        cityId: null,
        areaId: null,
        address: "",
        picture: "",
      },
      editTag: 0,
      uploadImageList: [], // 上传文件数据
      insuranceCompanyRules: {
        companyName: {
          required: true,
          message: "请输入保险公司名称",
          trigger: "blur",
        },
        contactsName: {
          required: true,
          message: "请输入联系人",
          trigger: "change",
        },
        phone: {
          pattern: this.$formRules.phone,
          required: true,
          trigger: "blur",
          message: this.$formRules.phoneMsg,
        },
        provinceId: [
          {
            required: true,
            message: "请选择省份",
            trigger: "blur",
          },
        ],
        cityId: [
          {
            required: true,
            message: "请选择城市",
            trigger: "blur",
          },
        ],
        areaId: [
          {
            required: true,
            message: "请选择区域",
            trigger: "blur",
          },
        ],
        address: [
          {
            required: true,
            message: "请填写详细地址",
            trigger: "blur",
          },
        ],
        certificateImg: [
          {
            required: false,
            trigger: "change",
            // validator: (rule, value, callback) => {
            //   if (this.insuranceCompanyForm.picture) {
            //     callback();
            //   } else {
            //     callback(new Error("请上传资质证书！"));
            //   }
            // },
          },
        ],
      },
      uploadUrl: "/api/vehicle/insurance/company/insuranceFileUpload",
      detailsAddress: "",
      imgUrl: "",
      imgList: [],
      hideUploadEdit: false,
    };
  },
  created() {
    this.getAccountList();
    this.getProvince();
  },
  mounted() {
    this.getTableList();
  },
  methods: {
    // // 设置关闭/开启状态
    // async closeStatus(row, state) {
    //   let { data: res } = await this.$axios.patch(
    //     "/api/maintenance/switch?id=" + row.id + "&state=" + state
    //   );
    //   if (res.code == 1) {
    //     this.$message.success(res.msg);
    //     this.getTableList();
    //   } else {
    //     this.$message.warning(res.msg);
    //   }
    // },
    query() {
      this.getTableList();
    },
    reset() {
      this.$resetForm(this, "queryForm");
      this.getTableList();
    },
    addCompany() {
      // 清除表单数据
      Object.keys(this.insuranceCompanyForm).map((item) => {
        this.insuranceCompanyForm[item] = "";
      });
      console.log(this.insuranceCompanyForm);
      this.uploadImageList = [];
      this.provinceList = [];
      this.cityList = [];
      this.areaList = [];
      if (this.editTag !== 0) {
        this.editTag = 0;
      }
      this.editTag = 1;
      this.dialogTitle = "新增";
      this.dialogVisible = true;
      this.getProvince();
      this.getCity(this.insuranceCompanyForm.provinceId);
      this.getDistrict(this.insuranceCompanyForm.cityId);
    },
    async editor(row) {
      // 清除表单数据
      Object.keys(this.insuranceCompanyForm).map((item) => {
        this.insuranceCompanyForm[item] = "";
      });
      this.provinceList = [];
      this.cityList = [];
      this.areaList = [];
      // 修改
      if (this.editTag !== 0) {
        this.editTag = 0;
      }
      this.editTag = 2;
      this.getProvince();
      this.getCity(row.provinceId);
      this.getDistrict(row.cityId);
      this.insuranceCompanyForm = { ...row };
      this.handleImgList(this.insuranceCompanyForm.picture);
      // 当上传文件列表大于  允许上传文件的最大数量   动态控制图片上传按钮的class类为true
      this.hideUploadEdit = this.uploadImageList.length >= 5;
      this.dialogTitle = "编辑";
      setTimeout(() => {
        this.dialogVisible = true;
      }, 800);
    },
    closeDialog() {
      // 清除数据
      Object.keys(this.insuranceCompanyForm).map((item) => {
        this.insuranceCompanyForm[item] = "";
      });
      this.uploadImageList = [];
      this.dialogVisible = false;
      this.editTag = 0;
    },
    // 大图预览
    handlePreview(file) {
      this.imgUrl = file.url;
      this.imageDialogVisible = true;
    },
    // 删除对应的文件
    handleRemove(file, fileList) {
      this.insuranceCompanyForm.picture = this.insuranceCompanyForm.picture
        .split(",")
        .filter(
          (item) => item.substring(item.lastIndexOf("/") + 1) != file.name
        )
        .join(",");
      // 当上传文件列表大于  允许上传文件的最大数量   动态控制图片上传按钮的class类为true
      this.hideUploadEdit = fileList.length >= 5;
    },
    // 处理文件数据
    handleImgList(urlString) {
      let list = urlString.split(",");
      list.forEach((item) => {
        if (item) {
          this.uploadImageList.push({
            name: item.substring(item.lastIndexOf("/") + 1),
            url: item,
          });
        }
      });
    },
    // 判断上传的是否为图片和限制图片格式、大小等
    uploadImage(file) {
      const img = file.name.substring(file.name.lastIndexOf(".") + 1);
      const isImg = img == "jpg" || "png" || "jpeg";
      const sizeLength = file.size / 1024 / 1024 < 2;
      if (!isImg) {
        this.$message.error("请上传正确的图片格式!");
        this.insuranceCompanyForm.picture = "";
      }
      // 可以限制图片的大小
      if (!sizeLength) {
        this.$message.error("上传图片大小不能超过10MB!");
        this.insuranceCompanyForm.picture = "";
      }
      return isImg && sizeLength;
    },
    // 上传成功的回调
    handleAvatarSuccess(res, file, fileList) {
      let list = [];
      let name = "";
      fileList.forEach((item) => {
        name = item.name;
        list.push(name);
      });
      // 得到图片url传递表单图片参数
      this.insuranceCompanyForm.picture = list.join();
      // 当上传文件列表大于  允许上传文件的最大数量   动态控制图片上传按钮的class类为true
      this.hideUploadEdit = fileList.length >= 5;
    },
    async delData(row) {
      //多选删除
      if (!row.id) {
        return;
      }
      this.$confirm("确定删除吗？", "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        let { data: res } = await this.$axios.delete(
          "/api/vehicle/insurance/company?id=" + row.id
        );
        if (res.code == 1) {
          this.$message.success("操作成功");
          let totalPage = Math.ceil((this.total - 1) / 10);
          let currentPage =
            this.currentPage > totalPage ? totalPage : this.currentPage;
          this.currentPage = currentPage < 1 ? 1 : currentPage;
          this.getTableList();
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    saveOrUpdate() {
      let data = [];
      this.$refs.editorForm.validate(async (valid) => {
        if (valid) {
          // 新增
          if (this.editTag == 1) {
            console.log("新增", this.insuranceCompanyForm);
            data = await this.$axios.post(
              "/api/vehicle/insurance/company/insert",
              this.insuranceCompanyForm
            );
          }
          // 修改
          if (this.editTag == 2) {
            console.log("修改", this.insuranceCompanyForm);
            this.insuranceCompanyForm.picture =
              this.insuranceCompanyForm.picture
                .split(",")
                .map((item) => {
                  return item.substring(item.lastIndexOf("/") + 1);
                })
                .join(",");
            data = await this.$axios.put(
              "/api/vehicle/insurance/company",
              this.insuranceCompanyForm
            );
          }
          let res = data.data;
          if (res.code == 1) {
            //信息提示
            this.$message.success("操作成功");
            this.dialogVisible = false;
            //刷新表格【？？？在关闭弹框之前刷新表格数据会触发第二次form表单校验】
            this.getTableList();
          } else {
            this.$message.warning(res.msg);
          }
        }
      });
    },
    back() {
      this.dialogVisible = false;
      // 移除校验效果
      this.$refs.editorForm.clearValidate();
    },
    // 查看详情数据
    checkDetails(rowData) {
      if (rowData.id) {
        this.detailsAddress = "";
        this.imgList = [];
        // 详情
        this.dialogDetails = true;
        this.detailsData = { ...rowData };
        let province = rowData.provinceName;
        let city = rowData.cityName;
        let area = rowData.areaName;
        this.detailsAddress = province + " , " + city + " , " + area;
        rowData.picture.split(",").forEach((item) => {
          if (item) {
            this.imgList.push(item);
          }
        });
      } else {
        this.$message.warning("未查询到数据！");
      }
    },
    // getAddressId() {
    //   // 得到地址信息
    //   this.getProvince(1, 1);
    //   if (this.insuranceCompanyForm.provinceId) {
    //     this.getProvince(this.insuranceCompanyForm.provinceId, 2);
    //   }
    //   if (this.insuranceCompanyForm.cityId) {
    //     this.getProvince(this.insuranceCompanyForm.cityId, 3);
    //   }
    // },
    // 打开省
    handleProvinceChange(val) {
      if (val) {
        if (
          this.insuranceCompanyForm.cityId ||
          this.insuranceCompanyForm.areaId
        ) {
          this.insuranceCompanyForm.cityId = "";
          this.insuranceCompanyForm.areaId = "";
        }
      }
    },
    // 打开市，获取市数据
    handleCityChange(val) {
      if (val) {
        if (this.insuranceCompanyForm.districtId) {
          this.insuranceCompanyForm.districtId = "";
        }
        this.getCity(this.insuranceCompanyForm.provinceId);
      }
    },
    // 打开区
    handleAreaChange(val) {
      if (val) {
        this.getDistrict(this.insuranceCompanyForm.cityId);
      }
    },
    // 获取省数据
    async getProvince() {
      let { data: res } = await this.$axios.get(
        "/api/property/management/dProvinceList"
      );
      if (res.code == 1) {
        this.provinceList = res.data;
      } else {
        this.$message.warning(res.msg);
      }
    },
    // 获取市区数据
    async getCity(provinceId) {
      // 选中省时得到省的id，使用该id匹配市
      let { data: res } = await this.$axios.get(
        "/api/property/management/dCityList",
        {
          params: { id: provinceId },
        }
      );
      if (res.code == 1) {
        this.cityList = res.data;
      } else {
        this.$message.warning(res.msg);
      }
    },
    // 获取区/县数据
    async getDistrict(cityId) {
      // 选中省时得到省的id，使用该id匹配市
      let { data: res } = await this.$axios.get(
        "/api/property/management/dAreaList",
        {
          params: { id: cityId },
        }
      );
      if (res.code == 1) {
        this.districtList = res.data;
      } else {
        this.$message.warning(res.msg);
      }
    },
    async getAccountList() {
      let { data: res } = await this.$axios.get("/api/sys/user/options", {
        params: { type: 5 },
      });
      if (res.code == 1) {
        this.accountList = res.data;
      } else {
        this.$message.warning(res.msg);
      }
    },

    // 获取表格数据
    async getTableList() {
      let obj = {};
      obj.companyName = this.queryForm.companyName;
      obj.contactsName = this.queryForm.contactsName;
      obj.page = this.currentPage;
      obj.limit = this.limit;
      let { data: res } = await this.$axios.get(
        "/api/vehicle/insurance/company/pagelist",
        {
          params: obj,
        }
      );
      if (res.code == 1) {
        this.tableData = res.data.list;
        this.total = res.data.totalCount;
      }
    },
    //pagesize改变时触发
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    //页数改变时触发
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.getTableList();
    },
  },
};
</script>

<style lang="scss" scoped>
.insuranceCompanyManagement-container {
  height: calc(100% - 60px);
  margin: 20px;
  padding: 20px 20px 0 20px;
  background: #fff;
  .insuranceCompanyDialog {
    /deep/ .el-dialog {
      min-width: 840px;
      .el-dialog__body {
        .el-form-item__label-wrap {
          margin-left: 0 !important;
        }
        .normal-uploader {
          margin-top: 10px;
          .el-upload-list--picture-card .el-upload-list__item {
            margin: 0 20px 20px 0;
          }
        }
        .hide {
          .el-upload--picture-card {
            display: none;
          }
        }
      }
    }
    /deep/ .el-form-item__content {
      width: auto !important;
      .myUpload {
        margin-top: 20px;
      }
      .el-input {
        width: 200px !important;
      }
    }
    .select-list {
      display: flex;
      /deep/ .el-form-item__label:before {
        content: "*";
        color: #f56c6c;
        margin-right: 4px;
      }
      /deep/ .el-form-item__content {
        width: 90% !important;
        .el-input {
          width: auto !important;
        }
      }
    }
  }
  .details-dialog {
    /deep/ .el-dialog {
      min-width: 700px;
      .el-dialog__body {
        height: 500px;
        overflow-y: auto;
      }
      .img-show-list {
        padding-top: 20px;
        img {
          display: inline-block;
          object-fit: cover;
        }
        .noData{
          color: #ccc;
        }
      }
    }
    .row-line {
      margin-bottom: 26px !important;
      .label {
        width: 110px;
        font-weight: 600;
      }
      .iconfont {
        color: #0094ff;
      }
    }
  }
}
.upload-dialog {
  /deep/ .el-dialog {
    .el-dialog__body {
      padding-top: 30px !important;
    }
  }
}
</style>
